import axios from "axios";
import { KrijgsmanLoboFerreiraRequest } from "../../types/model/calculation";
import { SessionStore } from "../../types/store";
import { newAbortSignal } from "../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/calculations/captures`;

export const calculateKrijgsmanLoboFerreira = async (
  captureId: number,
  inputId: number,
  payload: KrijgsmanLoboFerreiraRequest,
): Promise<any> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const res = await axios.post(`${BASE_URL}/${captureId}/krijgsman-lobo-ferreira/inputs/${inputId}`, payload, {
    headers: {
      "content-type": "application/json",
      "x-access-token": session?.accessToken,
    },
    timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
    signal:
      AbortSignal.timeout === undefined
        ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
        : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
  });

  return res.data;
};
